import React from "react"

export default function YSVG (props){
    return (
        <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.4524 0.11792L12 1.20358L5.2897 10.8821H3.74206L0 5.63861L1.54764 4.19492L4.51588 6.96681L10.4524 0.11792Z" fill="#3DA172"/>
        </svg>
    );
}

